import { defineMessages } from 'react-intl';

import Chat from 'src/assets/images/Chat.png';
import Hand from 'src/assets/images/Hand.png';
import Headphones from 'src/assets/images/Headphones.png';
import Suitcase from 'src/assets/images/Suitcase.png';

const messages = {
  header: defineMessages({
    title: {
      defaultMessage: 'What are Circles?',
    },
    description: {
      defaultMessage: 'Learn about Circles, live community sessions led by therapists and coaches.',
    },
  }),
  cards: [
    {
      image: Hand,
      ...defineMessages({
        title: {
          defaultMessage: 'Join a safe space',
        },
        description: {
          defaultMessage: 'Led by therapists and coaches who specialize in the areas they support',
        },
      }),
    },

    {
      image: Headphones,
      ...defineMessages({
        title: {
          defaultMessage: 'Choose a format that works best for you',
        },
        description: {
          defaultMessage:
            'Workshops, listen & learns, and discussions on topics that matter to you',
        },
      }),
    },
    {
      image: Suitcase,
      ...defineMessages({
        title: {
          defaultMessage: 'Learn new skills and take action',
        },
        description: {
          defaultMessage: 'New concepts and tools that you can put into practice right away',
        },
      }),
    },
    {
      image: Chat,
      ...defineMessages({
        title: {
          defaultMessage: 'Access top care professionals',
        },
        description: {
          defaultMessage: 'An inclusive community environment to uplift and support one another',
        },
      }),
    },
  ],
};

export default messages;
